module.exports = __webpack_public_path__ + "static/media/4-copy.9a49e9c9.svg";